import {Client} from "../../API";
import {onUpdateClient} from "../../graphql/subscriptions";
import {getClient} from "../../graphql/queries";

import {ActiveRecord} from "./ActiveRecord";

import {ClientDataUtils} from "../../shared/utils/clientDataUtils";
import {ClientInApp, ClientMeta} from "../../shared/types/SubscriptionTypes";
import {BasicDataSourceDeps} from "../../platform/services/types/DataSourceDependencies";
import {queryGqlApi} from "../../graphql/queryGqlApi";

export class ClientActiveRecord extends ActiveRecord<Client, ClientInApp> {
    id: string;
    deps: BasicDataSourceDeps;
    _modelName = 'Client';
    _subscriptionGQL = onUpdateClient;
    private currentMeta?: ClientMeta;

    constructor(deps: BasicDataSourceDeps, id: string) {
        super();
        this.deps = deps;
        this.id = id;
    }

    getWsClient() {
        return this.deps.dataClientService.getWsClientByKey('pgServer');
    };

    async loadGQLFetch(): Promise<Client> {
        const clientDb = await queryGqlApi(
            getClient,
            {
                id: this.id
        },
        this.deps.dataClientService,
        this.deps.authService,
        'pgServer'
    );
        return clientDb;
    }

    mapServerResponseToLocalRow(clientDB: Client) {
        const parsed = ClientDataUtils.parseRawClientData(clientDB);
        if (this.currentMeta) {
            parsed.meta = this.currentMeta;
        }
        return parsed;
    }

    updateMeta(meta: ClientMeta) {
        this.currentMeta = meta;
        if (this.row) {
            this._setRow({
                ...this.row,
                meta,
            });
        }
    }
}
